import { Injectable } from "@angular/core"
import { AppService } from "src/app/core/services/app.service"
import { environment } from "src/environments/environment"
import { map } from "rxjs/operators"
import { SegmentPaginateFilterRequest } from "../models/segment/segment-paginate-filter-request"
import { SegmentPostPutRequest } from "../models/segment/segment-post-put-request"
import { DEFAULT_PAGE_SIZE } from "../lib/constants"
import { HttpClient, HttpParams } from "@angular/common/http"
import {
  CustomURLEncoder,
  isNullOrUndefined,
} from "src/app/core/helpers/http-params-extensions"

@Injectable()
export class SegmentService {
  private post_segment_url: string
  private get_segment_url: string
  private get_segment_id_url: string
  private get_segment_grade_url
  private put_segment_url: string

  constructor(private httpClient: HttpClient) {
    this.buildUrls(environment.endpointSegment.url)
  }

  private buildUrls(segmentUrl: string) {
    this.post_segment_url =
      segmentUrl + environment.endpointSegment.routes.post_segment
    this.get_segment_id_url =
      segmentUrl + environment.endpointSegment.routes.get_segment_id
    this.get_segment_url =
      segmentUrl + environment.endpointSegment.routes.get_segment
    this.get_segment_grade_url =
      segmentUrl + environment.endpointSegment.routes.get_segment_grade
    this.put_segment_url =
      segmentUrl + environment.endpointSegment.routes.put_segment
  }

  postSegment(segment: SegmentPostPutRequest) {
    return this.httpClient.post(this.post_segment_url, segment)
  }

  getOne(segmentId: string, schoolId: string) {
    return this.httpClient.get<any>(
      this.get_segment_id_url
        .replace("{segmentId}", segmentId)
        .replace("{schoolId}", schoolId)
    )
  }

  getSegmentByGradeId(gradeId: string, schoolId: string) {
    const params = new HttpParams()
      .set("gradeId", gradeId)
      .set("schoolId", schoolId)

    return this.httpClient.get<any>(this.get_segment_grade_url, { params })
  }

  getAllSegments(segment: any) {
    let params = new HttpParams({ encoder: new CustomURLEncoder() })
    if (!isNullOrUndefined(segment.segmentName)) {
      params = params.set("segmentName", segment.segmentName)
    }
    if (!isNullOrUndefined(segment.segmentAlias)) {
      params = params.set("segmentAlias", String(segment.segmentAlias))
    }
    if (!isNullOrUndefined(segment.schoolId)) {
      params = params.set("schoolId", String(segment.schoolId))
    }
    if (!isNullOrUndefined(segment.gradeId)) {
      params = params.set("gradeId", String(segment.gradeId))
    }

    params = params.set(
      "askPage",
      String(!isNullOrUndefined(segment.askPage) ? segment.askPage : 1)
    )
    params = params.set(
      "itensPerPage",
      String(
        !isNullOrUndefined(segment.itensPerPage)
          ? segment.itensPerPage
          : DEFAULT_PAGE_SIZE
      )
    )

    if (!isNullOrUndefined(segment.orderByFilter)) {
      params = params.set("orderByFilter", String(segment.orderByFilter))
    }
    if (!isNullOrUndefined(segment.isDesc)) {
      params = params.set("IsDesc", String(segment.isDesc))
    }

    return this.httpClient.get<any>(this.get_segment_url, { params })
  }

  putSegment(segment: SegmentPostPutRequest, id: string) {
    return this.httpClient.put(
      this.put_segment_url.replace("{segmentId}", id),
      segment
    )
  }
}
